<template>
    <div>
        <span class="text">{{ row[column.key] }}%</span>
        <span class="text" v-if="row['colonel_type'] === '1' && column['showPay']">{{ '(支出' + row['disburse_commission_rate'] + '%)' }}</span>
        <div class="ad-text" v-if="$isDy(row.platform_id) && row.service_rate_during_the && row.service_rate_during_the!= 0">
            <span class="mr-6">投放期</span>
            <span>{{ row.service_rate_during_the }}%</span>
        </div>
    </div>
</template>

<script>
import mixin from "@/components/tableCells/mixin";

export default {
    name: "serviceRateCell",
    mixins: [mixin]
}
</script>

<style scoped>
.text {
    overflow: hidden;
    text-overflow:ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}
.ad-text {
    font-size: 12px;
    color: #FF4F4F;
    white-space: nowrap;
  }
</style>
